import { Add, Delete } from '@mui/icons-material'
import { Box, IconButton, Stack, TextField, Typography, Button } from '@mui/material'
import { FieldDef } from '../types'

interface Props {
  field: FieldDef
  value: string[]
  onChange: (v: string[]) => void
}

export default function ListWidget({ field, value, onChange }: Props) {
  const items = value || []

  const update = (i: number, v: string) => {
    const next = [...items]
    next[i] = v
    onChange(next)
  }

  const add = () => onChange([...items, ''])
  const remove = (i: number) => onChange(items.filter((_, idx) => idx !== i))

  return (
    <Stack spacing={1}>
      <Typography variant="caption" color="text.secondary">
        {field.label}
      </Typography>
      {items.map((item, i) => (
        <Stack key={i} direction="row" spacing={1}>
          <TextField
            value={item}
            onChange={(e) => update(i, e.target.value)}
            size="small"
            fullWidth
          />
          <IconButton onClick={() => remove(i)} size="small" aria-label={`Remove item ${i + 1}`}>
            <Delete fontSize="small" />
          </IconButton>
        </Stack>
      ))}
      <Box>
        <Button onClick={add} startIcon={<Add />} size="small">
          Add item
        </Button>
      </Box>
    </Stack>
  )
}
